import { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap'
import 'react-datepicker/dist/react-datepicker.css'
import ptBR from 'date-fns/locale/pt-BR'
import ReactDatePicker, { registerLocale } from 'react-datepicker'
import ErrorText from '../ErrorText'
import * as S from './styles'

type Props = {
  onChange: (date: Date | null) => void
  label: string
  errorMessage?: string
  defaultValue?: Date | null
  allowEmpty?: boolean
  placeholder?: string
}

export const DateInput = ({
  onChange,
  label,
  errorMessage,
  defaultValue,
  allowEmpty = false,
  placeholder = 'Selecione uma data',
  ...other
}: Props) => {
  const [dateSelected, setDateSelected] = useState<Date | null>(
    defaultValue !== undefined ? defaultValue : allowEmpty ? null : new Date()
  )
  registerLocale('ptBR', ptBR)

  useEffect(() => {
    onChange(dateSelected)
  }, [dateSelected])

  return (
    <Form.Group>
      {label && (
        <Form.Label>
          <strong>{label}</strong>
        </Form.Label>
      )}
      <S.DateInput>
        <ReactDatePicker
          locale="ptBR"
          dateFormat="dd/MM/yyyy"
          selected={dateSelected}
          onChange={(date: Date | null) => {
            setDateSelected(date)
          }}
          placeholderText={placeholder}
          isClearable={allowEmpty}
        />
      </S.DateInput>
      {errorMessage && <ErrorText text={errorMessage} />}
    </Form.Group>
  )
}
